import { useEffect, useState } from "react";
import api from "@/lib/api";
import AppLayout from "@/components/AppLayout";
import { ExternalLink } from "lucide-react";

export default function LegislacionPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/legislacion").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <AppLayout title="Legislación" subtitle="Normativa de referencia">
      <div className="space-y-px bg-border border border-border" data-testid="legislacion-list">
        {items.map((it) => (
          <div key={it.id} className="bg-white p-6">
            <h3 className="font-head text-lg font-bold text-slate-900">{it.titulo}</h3>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{it.contenido}</p>
            {it.url && (
              <a href={it.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 brand-accent-text text-sm mt-3 underline">
                Ver fuente <ExternalLink size={13} />
              </a>
            )}
          </div>
        ))}
      </div>
    </AppLayout>
  );
}
